import React, { Component } from 'react';
import EditOrder from './../../orders/edit';
import './styles.css';
import { titleHead } from './../../../services/helper'
import history from './../../../services/history'

class AddOrderFromShipment extends Component {
    componentDidMount() {
        titleHead('Create Order From Shipment')
    }

    render() {
        return (
            <div id='add-order-from-shipment'>
                <EditOrder
                    addOrderInShipment
                    order_id={this.props.package_id}
                />
            </div>
        );
    }
}

export default AddOrderFromShipment;


// WEBPACK FOOTER //
// ./src/containers/shipments/add-order-from-shipment/index.js